import logo from '@/assets/logo.png';
import { Space } from 'antd';
import React from 'react';

export const HeaderTitle: React.FC<{ title?: string }> = ({}) => {
  return (
    <Space size="small">
      <div className="h-12 w-40 flex items-center justify-center">
        <img src={logo} alt="logo" width={'100%'} />
      </div>
      {/* <span style={{ fontWeight: 400, fontSize: 20 }}>{title}</span> */}
    </Space>
  );
};
